import React from 'react';
import { Container, Box, Typography } from '@mui/material';

const SectionContainer = ({ title, subtitle, children, bgColor = 'transparent', py = 8, ...props }) => {
    return (
        <Box sx={{ backgroundColor: bgColor, py }} {...props}>
            <Container maxWidth="lg">
                {(title || subtitle) && (
                    <Box sx={{ textAlign: 'center', mb: 6 }}>
                        {title && (
                            <Typography variant="h2" component="h2" gutterBottom>
                                {title}
                            </Typography>
                        )}
                        {subtitle && (
                            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto', mb: 4 }}>
                                {subtitle}
                            </Typography>
                        )}
                    </Box>
                )}
                {children}
            </Container>
        </Box>
    );
};

export default SectionContainer;
